<template>
    <div>
        <el-card>
            <div class="flex justify-between">
                <div>
                    <div class="text-[#999] text-[12px]">帖子ID：{{ detail.id }}</div>
                    <div class="flex gap-x-3 mt-3">
                        <img class="w-15 h-15 rounded-full"
                            src="http://gips0.baidu.com/it/u=3602773692,1512483864&fm=3028&app=3028&f=JPEG&fmt=auto?w=960&h=1280"
                            alt="avatar" />
                        <div>
                            <div class="font-bold">{{ detail.userName }}</div>
                            <div class="text-[#999] text-[12px]">{{ detail.phone }}</div>
                        </div>
                    </div>
                </div>
                <div class="text-[#999] text-[12px]">发布时间：{{ detail.publishTime }}</div>
            </div>
            <el-divider></el-divider>
            <div class="flex flex-wrap gap-x-3">
                <img v-for="item in detail.imageUrls.split(',')" class="h-40 rounded" :src="item" alt="评论图片"
                    :key="item" />
            </div>
            <el-divider></el-divider>
            <el-form>
                <el-form-item label="审核人：" class="mb-0">
                    {{ detail.auditorName }}
                </el-form-item>
                <el-form-item label="审核时间：" class="mb-0">
                    {{ detail.auditTime || detail.autoAuditTime }}
                </el-form-item>
                <el-form-item label="机审结果：" class="mb-0">
                    <el-tag type="success" size="mini">{{ { 2: '通过', 3: '不通过' }[detail.autoAuditResult] }}</el-tag>
                </el-form-item>
            </el-form>
        </el-card>
        <div class="mt-3">
            <el-button type="primary" size="mini" @click="handleUpdateStatus">{{ detail.shelfStatus === 1 ? '下架' : '上架'
            }}</el-button>
            <el-button size="mini" @click="visible = true">推荐</el-button>
            <el-button type="danger" size="mini" @click="handleDelete">删除</el-button>
        </div>
        <el-dialog title="推荐配置" :visible.sync="visible" width="500px">
            <div class="text-[#999] mb-5">数字越大排序越靠前</div>
            <el-form :model="form" ref="form" :rules="rules" label-width="120px">
                <el-form-item label="排序权重" prop="recommendWeight">
                    <el-input v-model="form.recommendWeight" placeholder="请输入排序权重" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="visible = false">取 消</el-button>
                <el-button type="primary" @click="handleConfirm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { detail, edit, del, postTop } from "@/api/community/post";
export default {
    name: 'PostDetail',
    data() {
        return {
            visible: false,
            form: {
                recommendWeight: '',
            },
            rules: {
                recommendWeight: [{ required: true, message: '请输入排序权重' }],
            },
            detail: {},
            id: '',
        }
    },
    mounted() {
        this.id = this.$route.query.id;
        this.getDetail();
    },
    methods: {
        getDetail() {
            detail({ id: this.id }).then(({ code, result, message }) => {
                if (code == 200) {
                    this.detail = result;
                } else {
                    this.$message.error(message);
                }
            });
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const params = {
                    id: this.id,
                    recommendWeight: this.form.recommendWeight,
                }
                postTop(params).then(({ code, message }) => {
                    if (code == 200) {
                        this.$message.success('操作成功');
                        this.visible = false;
                        this.getDetail();
                    } else {
                        this.$message.error(message);
                    }
                });
            });
        },
        handleUpdateStatus() {
            const params = {
                id: this.id,
                shelfStatus: this.detail.shelfStatus === 1 ? 0 : 1,
            };
            edit(params).then(({ code, message }) => {
                if (code == 200) {
                    this.$message.success('操作成功');
                    this.getDetail();
                } else {
                    this.$message.error(message);
                }
            });
        },
        handleDelete() {
            this.$confirm('确定删除该帖子吗？', '提示', {
                type: 'warning'
            }).then(() => {
                del({ id: this.id }).then(({ code, message }) => {
                    if (code == 200) {
                        this.$message.success('删除成功');
                        this.$router.back();
                    } else {
                        this.$message.error(message);
                    }
                });
            }).catch(() => { });
        }
    }
}
</script>